import {
  createComponent,
  type ElementWithProps
} from '@carvana/merch-components';
import cx from 'classnames';
import PriceArrow from '~/icons/PriceArrow';

export const SectionWrapper = createComponent('div', {
  className:
    'border-zinc-200 relative z-0 flex h-[317px] overflow-hidden rounded-md border border-grey-2 bg-white m:h-[174px] m:w-full l:h-[208px] l:max-h-[208px]'
});

export const InnerWrapper = createComponent('div', {
  className:
    'absolute top-0 flex h-full w-full flex-col-reverse items-center justify-between p-24 m:flex-row m:pl-[152px] l:pl-[184px]'
});

export const ImageWrapper = createComponent('div', {
  className: 'flex max-w-[328px] justify-end self-center'
});

export const ContentWrapper = createComponent('div', {
  className:
    'flex flex-col items-center gap-24 m:items-start l:min-w-[390px] l:max-w-full'
});

export const ContentText = createComponent('span', {
  className: 'text-center text-blue-6 tl-header-m m:text-left l:tl-header-xl'
});

export const ArrowWrapper = createComponent('div', {
  className:
    'full absolute left-[-41px] top-[-41px] h-[122px] w-[122px] rounded-full bg-green-2 m:-left-80 m:top-1/2 m:h-[210px] m:w-[210px] m:-translate-y-1/2 l:left-[-73px] l:h-[224px] l:w-[224px]'
});

export const NewPriceArrow = createComponent<
  ElementWithProps<{ rotateArrow: boolean }>
>(PriceArrow, ({ rotateArrow }) => ({
  className: cx(
    'absolute right-32 top-[58px] h-32 w-32 transform m:right-[52px] m:top-1/2 m:h-auto m:w-auto m:-translate-y-1/2',
    {
      '-rotate-45': rotateArrow
    }
  )
}));
